/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {ResponsePageProperties} from '../../../../interfaces/_models'

const mappedLabel = (label: string): string => {
    if (label === '&laquo; Anterior') {
        return 'Anterior'
    }

    if (label === 'Siguiente &raquo;') {
        return 'Siguiente'
    }

    return label
}

interface Props {
    pagination: ResponsePageProperties
    isLoading: boolean
    onChange: (page: number) => void
}

interface PaginationLink {
    label: string
    page: number
    active: boolean
}

const CustomPagination = ({pagination, isLoading, onChange}: Props) => {
    const {currentPage, totalPages} = pagination
    const visiblePages = 10
    const halfVisible = Math.floor(visiblePages / 2)
    let startPage = Math.max(1, currentPage - halfVisible)
    let endPage = Math.min(totalPages, currentPage + halfVisible)

    if (endPage - startPage + 1 < visiblePages) {
        if (currentPage <= halfVisible) {
            endPage = Math.min(totalPages, startPage + visiblePages - 1)
        } else {
            startPage = Math.max(1, endPage - visiblePages + 1)
        }
    }

    const paginationLinks: PaginationLink[] = []
    if (currentPage > 1) {
        paginationLinks.push({
            label: 'Anterior',
            page: currentPage - 1,
            active: false,
        })
    }
    for (let page = startPage; page <= endPage; page++) {
        paginationLinks.push({
            label: page.toString(),
            page: page,
            active: page === currentPage,
        })
    }
    if (currentPage < totalPages) {
        paginationLinks.push({
            label: 'Siguiente',
            page: currentPage + 1,
            active: false,
        })
    }

    const updatePage = (page: number | undefined | null) => {
        if (!page || isLoading || pagination.currentPage === page) {
            return
        }

        onChange(page)
    }

    return (
        <div className='row'>
            <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>
            <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
                <div id='kt_table_users_paginate'>
                    <ul className='pagination'>
                        <li
                            className={clsx('page-item', {
                                disabled: isLoading || pagination.currentPage === 1,
                            })}
                        >
                            <a
                                onClick={() => updatePage(1)}
                                style={{cursor: 'pointer'}}
                                className='page-link'
                            >
                                Primera
                            </a>
                        </li>
                        {paginationLinks
                            ?.map((link) => {
                                return {...link, label: mappedLabel(link.label)}
                            })
                            .map((link) => (
                                <li
                                    key={link.label}
                                    className={clsx('page-item', {
                                        active: pagination.currentPage === link.page,
                                        disabled: isLoading,
                                        previous: link.label === 'Anterior',
                                        next: link.label === 'Siguiente',
                                    })}
                                >
                                    <a
                                        className={clsx('page-link', {
                                            'page-text':
                                                link.label === 'Anterior' ||
                                                link.label === 'Siguiente',
                                            'me-5': link.label === 'Anterior',
                                        })}
                                        onClick={() => updatePage(link.page)}
                                        style={{cursor: 'pointer'}}
                                    >
                                        {mappedLabel(link.label)}
                                    </a>
                                </li>
                            ))}
                        <li
                            className={clsx('page-item', {
                                disabled:
                                    isLoading || pagination.currentPage === pagination.totalPages,
                            })}
                        >
                            <a
                                onClick={() => updatePage(pagination.totalPages)}
                                style={{cursor: 'pointer'}}
                                className='page-link'
                            >
                                Última
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default CustomPagination
